import React from 'react'
import About from '../components/About/About'
import Banner from '../components/Banner/Banner'
import Portfolio from '../components/Portfolio/Portfolio'
import ScrollToTop from '../components/ScrollToTop/ScrollToTop'
import Skills from '../components/Skills/Skills'
import Contact from './../components/Contact/Contact'


const Home = () => {

    return (
        <div>
            <main>
                <section>
                    <Banner />
                </section>
                <section>
                    <About />
                </section>
                <section>
                    <Skills />
                </section>
                <section>
                    <Portfolio />
                </section>
                <section>
                    <Contact />
                </section>
            </main>
            <ScrollToTop />
        </div>
    )
}

export default Home
